import { C } from "../../constants/colors";

export function Logo({ size="md" }) {
  const fs = size==="sm"?"1rem":size==="lg"?"1.9rem":"1.3rem";
  const ds = size==="sm"?"6px":size==="lg"?"11px":"7px";
  return (
    <span style={{ display:"inline-flex",alignItems:"baseline",gap:"2px",fontFamily:"'DM Mono',monospace",fontWeight:400,fontSize:fs,letterSpacing:"-0.5px",color:"#e8d5b7",userSelect:"none" }}>
      opencall<span style={{ display:"inline-block",width:ds,height:ds,borderRadius:"50%",background:C.clay,marginBottom:"1px",flexShrink:0 }}/>
    </span>
  );
}
